import { render } from "./KpiQuestionAssignment.vue?vue&type=template&id=b10a93da&scoped=true"
import script from "./KpiQuestionAssignment.vue?vue&type=script&lang=js"
export * from "./KpiQuestionAssignment.vue?vue&type=script&lang=js"

import "./KpiQuestionAssignment.vue?vue&type=style&index=0&id=b10a93da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b10a93da"]])

export default __exports__